import { baseApi, TAGS } from 'shared/api';
import type { BaseResponse } from 'shared/models/common';

import type { CooperativeCommonCase } from '../models';
import type { GetCooperativeCommonCasesListQueryParameters } from './requestParameters';

export const cooperativeCommonCasesApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getCooperativeCommonCasesList: build.query<
      CooperativeCommonCase[],
      GetCooperativeCommonCasesListQueryParameters
    >({
      query: ({ cooperativeId, isConstructor = false }) => ({
        url: `${
          isConstructor ? '/constructor' : ''
        }/cooperatives/${cooperativeId}/cases/common`,
        method: 'GET',
      }),
      providesTags: [TAGS.COOPERATIVE_COMMON_CASES],
      transformResponse: (response: BaseResponse<CooperativeCommonCase[]>) =>
        response.Data,
    }),
  }),
});
